import React, { useState } from 'react'
import { Box, Popover, Typography } from '@mui/material'

export default function avgColumn(sites, avgByBranchSite) {
	return {
		name: 'name',
		setBodyRowProps: () => ({ sx: { p: 0, backgroundColor: 'primary.main' } }),
		setBodyCellProps: () => ({
			sx: { p: 0, verticalAlign: 'top', userSelect: 'none', cursor: 'default', backgroundColor: 'primary.main' },
		}),
		render: branch => <Box sx={{ borderBottom: 2, borderColor: 'primary.main' }}>
			{sites.map((site, index) => {
				const siteAvg = avgByBranchSite?.[branch]?.[site]
				return <SiteAvgCell key={`${site}-${index}`} avg={siteAvg?.avg} byLor={siteAvg?.byLor} />
			})}
		</Box>
	}
}

function SiteAvgCell({ avg, byLor }) {
	const [anchor, setAnchor] = useState(null)

	return <Box sx={{ p: 1, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
		{avg != null
			? <>
				<Box
					onClick={e => { e.stopPropagation(); setAnchor(e.currentTarget) }}
					sx={{
						cursor: 'pointer',
						bgcolor: 'primary.dark',
						px: 1.5,
						py: 0.25,
						borderRadius: 1,
						'&:hover': { opacity: 0.75 },
					}}
				>
					<Typography variant="caption" sx={{ color: 'secondary.contrastText', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
						⌀ {avg}
					</Typography>
				</Box>
				<Popover
					open={Boolean(anchor)}
					anchorEl={anchor}
					onClose={() => setAnchor(null)}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Box sx={{ p: 2, minWidth: 140 }}>
						<Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>Avg by LOR</Typography>
						{Object.entries(byLor || {}).map(([lor, lorAvg]) => (
							<Box key={lor} sx={{ display: 'flex', justifyContent: 'space-between', gap: 3 }}>
								<Typography variant="body2" fontWeight="bold">L{lor}</Typography>
								<Typography variant="body2">{lorAvg ?? '—'}</Typography>
							</Box>
						))}
					</Box>
				</Popover>
			</>
			: <Typography variant="caption" sx={{ color: 'text.disabled' }}>—</Typography>
		}
	</Box>
}
